export default __webpack_public_path__ + "static/media/logo-jsi.1fb5c86d.jpeg";